import { Component } from '@angular/core';
import { LoadingService } from 'src/app/Service/loading.service';

@Component({
    selector: 'app-under-construction',
    template: `
    <div class="content_wrapper no-header full_gradient under-construction">
    <!-- Body content -->
        <div class="body-content">
            <div class="content-area vh-100 d-flex align-items-center justify-content-center hero_bg">
                <div class="under-construction-content text-center">
                    <a class="under-logo" routerLink="/">
                        <img src="/assets/images/familycentral-logo.svg" width="140" height="70" alt="Family central logo" class="fc_logo">
                    </a>
                    <h1 class="h1 mt-5">This section of Family Central is still under development.</h1>
                    <a routerLink="/" class="primary_btn">Go To Homepage</a>
                    <!-- <p>Anticipated final delivery by Sept 30th</p> -->
                </div>
            </div>
        </div>
    </div> `,
    standalone: false
})
export class UnderConstructionComponent {
  constructor(private loader: LoadingService) {
    this.loader.HideLoading();
  }
}
